import { useState, useCallback } from 'react';
import { UsersApi } from '../../clients';

export const useUpdateFacilityUser = () => {
  const [state, setState] = useState({
    loading: false,
    error: null,
  });

  const setPartialState = (updates) => {
    setState((prevState) => ({ ...prevState, ...updates }));
  };

  const updateUser = useCallback(async (userId, data) => {
    if (!userId) {
      throw new Error('User ID is required');
    }

    setPartialState({
      loading: true,
      error: null,
    });

    try {
      const response = await UsersApi.updateFacilityUser(userId, data);
      setPartialState({
        loading: false,
        error: null,
      });
      return response.data;
    } catch (error) {
      console.error('Error updating facility user:', error);
      const errorMessage =
        error.response?.data?.message || 'Failed to update user';
      setPartialState({
        loading: false,
        error: errorMessage,
      });
      throw error;
    }
  }, []);

  return {
    ...state,
    updateUser,
  };
};
